import { pluralize } from '@trend-dev/ui-libs-utils/utils/pluralize';

export const getAlmostOverTitle = (value: number) => {
    return `До\u00A0окончания встречи ${value}\u00A0${pluralize(value, ['минута', 'минуты', 'минут'])}`;
};
export const text = 'Если есть что еще обсудить, продлите встречу еще на\u00A030\u00A0минут';
export const cancelText = 'Отменить';
export const acceptText = 'Продлить встречу';
